module.exports = __webpack_public_path__ + "img/instagram.fbfa571b.svg";